import React from 'react';
import { IProps } from './types';
import { InsProcessStep } from 'constants/enums/insProcessStep.enum';

const ProcessBar: React.FC<IProps> = (props) => {
  const getClassName = (step:InsProcessStep) => {
    let classNames:string[] = ['process-bar__item'];

    classNames = step <= props.activeStep ? [...classNames, 'process-bar__item--active'] : [...classNames];

    if (step === props.activeStep) classNames.push('process-bar__item--mobile-active');

    return classNames.join(' ');
  };

  return (
    <div className="process-bar">
      <div className={getClassName(InsProcessStep.InsureProcessCalc)}>
        <div className="process-bar__item-icon process-bar__item-icon--calc" />
        <span>我要試算</span>
      </div>
      <div className={props.activeStep === InsProcessStep.InsureProcessFill1st
        ? getClassName(InsProcessStep.InsureProcessFill1st)
        : getClassName(InsProcessStep.InsureProcessFill2nd)}
      >
        <div className="process-bar__item-icon process-bar__item-icon--fill" />
        <span>填寫資料</span>
      </div>
      <div className={props.activeStep === InsProcessStep.InsureProcessPreview
        ? getClassName(InsProcessStep.InsureProcessPreview)
        : getClassName(InsProcessStep.InsureProcessVerifyOTP)}
      >
        <div className="process-bar__item-icon process-bar__item-icon--preview" />
        <span>資料預覽</span>
      </div>
      <div className={getClassName(InsProcessStep.InsureProcessPayment)}>
        <div className="process-bar__item-icon process-bar__item-icon--pay" />
        <span>確認付款</span>
      </div>
      <div className={getClassName(InsProcessStep.InsureProcessSuccess)}>
        <div className="process-bar__item-icon process-bar__item-icon--success" />
        <span>成功投保</span>
      </div>
    </div>
  );
};

export default ProcessBar;
